import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Modal } from 'antd';

import SelectFunction from './SelectFunction';

class IndexModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedKeys: { checked: [], halfChecked: [] },
    };
  }

  componentDidMount() {}

  setStateCheckedKeys = checkedKeys => {
    this.setState({
      checkedKeys,
    });
  };

  submit = () => {
    const { roleUuid } = this.props;
    const {
      checkedKeys: { checked, halfChecked },
    } = this.state;
    const checkedKeys = checked.concat(halfChecked);
    this.props.onOk(roleUuid, checkedKeys, () => this.props.form.resetFields());
  };

  onCancel = () => {
    this.props.onCancel();
  };

  render() {
    const { roleUuid } = this.props;
    return (
      <Modal
        title="角色定义"
        visible={this.props.visible}
        onOk={this.submit}
        onCancel={this.onCancel}
      >
        <SelectFunction roleUuid={roleUuid} setStateCheckedKeys={this.setStateCheckedKeys} />
      </Modal>
    );
  }
}

export default connect(state => ({
  accountInfo: state.account_info,
}))(Form.create({ wrappedComponentRef: true })(IndexModal));



// WEBPACK FOOTER //
// ./src/components/boss/role/ModalRoleFuncAdd.js